import { render, staticRenderFns } from "./ComplainAddNew.vue?vue&type=template&id=298d32f4&"
import script from "./ComplainAddNew.vue?vue&type=script&lang=js&"
export * from "./ComplainAddNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports